<template>

<!--    <div class="container">-->
<!--&lt;!&ndash;        <div class="sideContainer">&ndash;&gt;-->
<!--&lt;!&ndash;            <SiderAside></SiderAside>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="rightContainer">-->
<!--&lt;!&ndash;            <div class="headContainer">&ndash;&gt;-->
<!--&lt;!&ndash;                <Nav></Nav>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div class="mainContainer">-->
<!--                <router-view></router-view>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->


    <div class="mainContainer">
        <router-view></router-view>
    </div>
</template>

<script>
import SiderAside from "@/components/SideAside.vue";
import Nav from "@/components/Nav.vue";

export default {
    data() {
        return {}
    },
    components: {
        SiderAside,
        Nav,
    }
}
</script>

<style>
/*.el-header {
    padding: 0 0;
    z-index: 200;
}

.el-container {
    height: 100vh;
}

.el-main {
    height: calc(100% - 90px);
}*/

.container {
    display: flex;
    /*width: 100vw;*/
    height: 100vh;
    min-width: 1280px;

}

.sideContainer {
    /*width: 368px;*/
    /*overflow: auto;*/
}

.rightContainer {
    flex: 1;
    /*margin-left: 20px;*/
    display: flex;
    flex-direction: column;
}

.rightContainer .headContainer {
    /*height: 81px;*/
    overflow: auto;
}

.rightContainer .mainContainer {
    flex: 1;
    overflow: auto;
}

.mainContainer {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

</style>
